module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header header-minimal"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Join Forum")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find CNpros ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/insuremoto"
    }
  }, [_vm._v("InsureMoto")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnsurveys"
    }
  }, [_vm._v("Take CNsurveys")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "businesses"
    }
  }, [_vm._v("Find Businesses")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help-me-find-a-cnpro"
    }
  }, [_vm._v("Help Me Find A CNpro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Logout")])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "header-nav-user"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('div', {
    staticClass: "user-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.user.user_image,
      "alt": "User Photo"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-nav-user-name"
  }, [_vm._v(_vm._s(_vm.user.user_fullname))])])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-statusbar"
  }, [_c('div', {
    staticClass: "header-statusbar-inner"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "header-statusbar-right"
  }, [_c('div', {
    staticClass: "hidden-xs visible-lg"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Dashboard")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "prompt",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('h1', {
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_vm._v("Your Referral Code")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "line-height": "1.8",
      "font-size": "18px"
    }
  }, [_vm._v("Refer friends and family with your unique Cityneeds Referral Code and earn N100 when the person you referred signups \r\n                                        and completes three transactions, one of which will include one CNpro service.\r\n                                    ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "title": "Copy Link and Share"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#000000",
      "background": "rgb(242, 248, 248)",
      "border": "1px solid #013d3f",
      "padding": "1em",
      "border-radius": "2px",
      "min-height": "3.5em"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.user.user_referral_code))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("copy")])])]), _vm._v(" "), _c('p', [(_vm.copy_succ) ? _c('span', {
    staticStyle: {
      "color": "#000000",
      "background": "#ffff00",
      "font-size": "12px",
      "padding": "3px"
    }
  }, [_vm._v("Referral Link Copied")]) : _vm._e()])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "src": "static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-statusbar-left"
  }, [_c('h1', {
    staticStyle: {
      "margin-left": "1.5em"
    }
  }, [_vm._v(" Dashboard ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6667e270"}!./src/components/Dashboard-Header/template.html
// module id = 298
// module chunks = 0